import {MetaTags} from '../interfaces/meta-tags.interface';

export const META_TAGS: { [key: string]: MetaTags } = {
  calculator: {
    title: 'Calculadora de CO2',
    description: 'Calculadora de emisiones de CO2 para transporte de mercancías. Calcula el impacto ambiental de tus envíos por tierra, mar y aire.',
    image: 'https://expert.mojito360.com/assets/Expert.jpg',
    url: 'https://expert.mojito360.com/calculator'
  },
  home: {
    title: 'Mojito360 Expert',
    description: '🚀 El primer agente de IA al servicio de tu logística.',
    image: 'https://expert.mojito360.com/assets/Expert.jpg',
    url: 'https://expert.mojito360.com'
  }
};
